import axios from 'axios';

// unauthorized error is handled by useRefresh, additionally don't log network errors
export const isAxiosErrorToFilter = (error: unknown): boolean => {
  return (
    axios.isAxiosError(error) && (error.response?.status === 401 || error.code === 'ERR_NETWORK')
  );
};
